import http from "@/axios";
import {
    ArtifactInfo,
    GroupInfo,
    RuneInfo,
    SpeedupInfo,
    UnlockInfo,
    UpdateInfo
} from "@/store/artifact/types";
import {Player} from "@/store/player/types";
import PlayerStore from "@/store/player";
import {WarriorClass} from "@/store/level/types";
import {ForceUpdateInfo} from "@/store/force/types";
import {CardType} from "@/store/card/types";

export default class ForceStore {

    public static forcesInfoByCreature(creatureId: number): Promise<ForceUpdateInfo[]> {
        return http.get('/api/force/getForcesInfoByCreature?creatureId=' + String(creatureId))
            .then(r => r.data)
            .then(listObj => {
                let ui: ForceUpdateInfo[] = Object.assign([], listObj);
                return ui;
            });
    };

    public static buyHammer(currentHammers: number): Promise<void> {
        return http.get('/api/force/buyHammer?currentCount=' + String(currentHammers))
            .then(r => r.data)
            .then(listObj => {
                PlayerStore.SET_HAMMERS_COUNT(currentHammers + 1);
            });
    };

    public static nextHammerPrice(currentHammers: number): Promise<number> {
        return http.get('/api/force/nextHammerPrice?currentCount=' + String(currentHammers))
            .then(r => r.data)
            .then(nextHammerPrice => {
                return nextHammerPrice;
            });
    };

    public static speedupForceUpdate(creatureId: number, warriorClass:WarriorClass): Promise<Player> {
        var params = new URLSearchParams();
        params.append('creatureId', String(creatureId));
        params.append('warriorClass', String(warriorClass));

        return http.post('/api/force/speedupUpdate', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                if (PlayerStore.GET_CARDS_STATE()?.activeCard === CardType.ELEPHANT || PlayerStore.GET_CARDS_STATE()?.activeCard === CardType.SNAKE) {
                    PlayerStore.SET_CARD_STATE({ activeCard: null });
                }
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    };

    public static startForceUpdate(creatureId: number, warriorClass: WarriorClass, targetRank: number): Promise<Player> {
        var params = new URLSearchParams();
        params.append('creatureId', String(creatureId));
        params.append('warriorClass', String(warriorClass));
        params.append('targetRank', String(targetRank));

        return http.post('/api/force/startUpdate', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                if (PlayerStore.GET_CARDS_STATE()?.activeCard === CardType.ELEPHANT || PlayerStore.GET_CARDS_STATE()?.activeCard === CardType.SNAKE) {
                    PlayerStore.SET_CARD_STATE({ activeCard: null });
                }
                PlayerStore.SET_PLAYER(player);
                return player;
            })
            .catch(error => {
                console.error(error);
                throw error;
            });
    }

    public static actualizeForces(): Promise<void> {
        return http.post('/api/force/actualizeForces')
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
            });
    };

    public static isTimeToActualize(): Promise<boolean> {
        return http.get('/api/force/isTimeToActualize')
            .then(r => r.data)
            .then(isTimeObj => {
                return JSON.parse(isTimeObj);
            });
    };

    public static clearForceNotifications(): Promise<Player> {
        return http.post('/api/force/clearNotifications')
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    };

    public static deleteForceNotification(notificationId: number): Promise<Player> {
        var params = new URLSearchParams();
        params.append('notificationId', String(notificationId));

        return http.post('/api/force/deleteNotification', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    };

    public static getAllForcesDiffs(): Promise<string[]> {
        return http.get('/api/force/getAllForcesDiffs' )
            .then(r => r.data)
            .then(listObj => {
                let ui: string[] = Object.assign([], listObj);
                return ui;
            });
    };

}
